/* ============================================================
   MY RARE AURA — COLLECTION EXPERIENCE JS
   Fixed mobile sort drawer + filters + wishlist + quick add
============================================================ */

(function () {
  'use strict';

  var WISHLIST_KEY = 'aurelleWishlist';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items || []));
    document.dispatchEvent(new CustomEvent('aurelle:wishlist-updated', {
      detail: { count: (items || []).length }
    }));
  }

  function setButtonLoading(button, text) {
    if (!button) return;
    button.dataset.originalText = button.dataset.originalText || button.textContent;
    button.disabled = true;
    button.textContent = text || 'Adding…';
  }

  function resetButton(button, text, delay) {
    if (!button) return;
    window.setTimeout(function () {
      button.disabled = false;
      button.textContent = text || button.dataset.originalText || 'Quick Add';
    }, delay || 1100);
  }

  /* ================= FILTER DRAWER ================= */

  function initFilters() {
    var open = qs('[data-aurelle-filter-open]');
    var close = qs('[data-aurelle-filter-close]');
    var form = qs('#AurelleCollectionFilters');

    if (open) {
      open.addEventListener('click', function () {
        document.body.classList.add('aurelle-filter-open');
      });
    }

    if (close) {
      close.addEventListener('click', function () {
        document.body.classList.remove('aurelle-filter-open');
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        document.body.classList.remove('aurelle-filter-open');
        document.body.classList.remove('aurelle-sort-open');
      }
    });

    if (form) {
      qsa('input[type="checkbox"]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          form.submit();
        });
      });
    }
  }

  /* ================= MOBILE SORT DRAWER ================= */

  function initSort() {
    var sortSelect = qs('[data-aurelle-sort-select]');
    var sortOpen = qs('[data-aurelle-sort-open]');

    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      if (sortSelect.form) sortSelect.form.submit();
    });

    if (!sortOpen) return;

    var drawer = document.createElement('div');
    drawer.className = 'aurelle-sort-drawer';
    drawer.innerHTML = [
      '<button type="button" class="aurelle-sort-drawer__overlay" data-aurelle-sort-close></button>',
      '<div class="aurelle-sort-drawer__panel">',
      '<div class="aurelle-sort-drawer__header">',
      '<span>Sort by</span>',
      '<button type="button" data-aurelle-sort-close aria-label="Close sort">×</button>',
      '</div>',
      '<div class="aurelle-sort-drawer__options"></div>',
      '</div>'
    ].join('');

    document.body.appendChild(drawer);

    var optionsWrap = qs('.aurelle-sort-drawer__options', drawer);

    qsa('option', sortSelect).forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'aurelle-sort-option';
      button.textContent = option.textContent;
      button.dataset.value = option.value;

      if (option.selected) {
        button.classList.add('is-active');
      }

      button.addEventListener('click', function () {
        sortSelect.value = button.dataset.value;

        document.body.classList.remove('aurelle-sort-open');

        if (sortSelect.form) {
          sortSelect.form.submit();
        }
      });

      optionsWrap.appendChild(button);
    });

    sortOpen.addEventListener('click', function () {
      document.body.classList.add('aurelle-sort-open');
    });

    qsa('[data-aurelle-sort-close]', drawer).forEach(function (button) {
      button.addEventListener('click', function () {
        document.body.classList.remove('aurelle-sort-open');
      });
    });
  }

  /* ================= WISHLIST ================= */

  function initWishlist() {
    function syncButtons() {
      var wishlist = readWishlist();

      qsa('[data-aurelle-collection-wishlist]').forEach(function (button) {
        var active = wishlist.some(function (item) {
          return String(item.id) === String(button.dataset.productId);
        });

        button.classList.toggle('is-wished', active);
        button.textContent = active ? '♥' : '♡';
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aurelle-collection-wishlist]');
      if (!button) return;

      var wishlist = readWishlist();
      var id = String(button.dataset.productId || '');

      var exists = wishlist.some(function (item) {
        return String(item.id) === id;
      });

      if (exists) {
        wishlist = wishlist.filter(function (item) {
          return String(item.id) !== id;
        });
      } else {
        wishlist.unshift({
          id: id,
          variantId: button.dataset.variantId || '',
          title: button.dataset.title || '',
          url: button.dataset.url || '',
          image: button.dataset.image || '',
          price: button.dataset.price || ''
        });
      }

      writeWishlist(wishlist.slice(0, 80));
      syncButtons();
    });

    document.addEventListener('aurelle:wishlist-updated', syncButtons);
    syncButtons();
  }

  /* ================= CART HELPERS ================= */

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function softOpenCartDrawer() {
    var drawer = qs('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (error) {}
    }

    drawer.classList.add('active', 'animate');
    document.body.classList.add('overflow-hidden');
  }

  function initQuickAdd() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aurelle-collection-quick-add]');
      if (!button || button.disabled) return;

      setButtonLoading(button, 'Adding…');

      addVariantToCart(button.dataset.variantId, 1)
        .then(function () {
          button.textContent = 'Added ✓';
          softOpenCartDrawer();
        })
        .catch(function () {
          button.textContent = 'Not Available';
        })
        .finally(function () {
          resetButton(button, button.dataset.originalText || 'Quick Add', 1300);
        });
    });
  }

  /* ================= QUICK VIEW ================= */

  function initQuickView() {
    var modal = qs('#AurelleCollectionQuickView');
    if (!modal) return;

    var imageWrap = qs('.aurelle-collection-qv__image', modal);
    var title = qs('.aurelle-collection-qv__content h2', modal);
    var price = qs('.aurelle-collection-qv__price', modal);
    var details = qs('.aurelle-collection-qv__details', modal);
    var add = qs('[data-aurelle-qv-add]', modal);

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-aurelle-collection-quick-view]');
      if (!trigger) return;

      if (imageWrap) {
        imageWrap.innerHTML = trigger.dataset.image
          ? '<img src="' + trigger.dataset.image + '" width="1000" height="1333" alt="' + (trigger.dataset.title || '') + '" loading="lazy">'
          : '';
      }

      if (title) title.textContent = trigger.dataset.title || '';

      if (price) {
        price.innerHTML = trigger.dataset.compare
          ? '<span>' + trigger.dataset.price + '</span><s>' + trigger.dataset.compare + '</s>'
          : '<span>' + trigger.dataset.price + '</span>';
      }

      if (details) details.href = trigger.dataset.url || '#';

      if (add) {
        add.dataset.variantId = trigger.dataset.variantId || '';
        add.disabled = trigger.dataset.available !== 'true';
        add.textContent = trigger.dataset.available === 'true' ? 'Add to Bag' : 'Sold Out';
      }

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    });

    qsa('[data-aurelle-qv-close]', modal).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (add) {
      add.addEventListener('click', function () {
        if (!add.dataset.variantId || add.disabled) return;

        setButtonLoading(add, 'Adding…');

        addVariantToCart(add.dataset.variantId, 1)
          .then(function () {
            add.textContent = 'Added ✓';
            closeModal();
            softOpenCartDrawer();
          })
          .catch(function () {
            add.textContent = 'Not Available';
          })
          .finally(function () {
            resetButton(add, 'Add to Bag', 1300);
          });
      });
    }
  }

  /* ================= LOAD MORE ================= */

  function initLoadMore() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-aurelle-load-more]');
      if (!link) return;

      event.preventDefault();

      var grid = qs('[data-aurelle-product-grid]');
      if (!grid) return;

      var originalText = link.textContent;
      link.textContent = 'Loading…';
      link.style.pointerEvents = 'none';

      fetch(link.href)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = qsa('[data-aurelle-product-card]', doc);
          var nextLink = qs('[data-aurelle-load-more]', doc);

          newCards.forEach(function (card) {
            grid.appendChild(document.importNode(card, true));
          });

          if (nextLink) {
            link.href = nextLink.href;
            link.textContent = originalText;
            link.style.pointerEvents = '';
          } else {
            var pagination = link.closest('.aurelle-pagination');
            if (pagination) pagination.remove();
          }

          document.dispatchEvent(new CustomEvent('aurelle:wishlist-updated'));
        })
        .catch(function () {
          link.textContent = 'Try Again';
          link.style.pointerEvents = '';
        });
    });
  }

  function init() {
    initFilters();
    initSort();
    initWishlist();
    initQuickAdd();
    initQuickView();
    initLoadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();